<template>
	<div id="app">
		<HeaderBar/>
		<transition name="fade-in" mode="out-in">
			<router-view/>
		</transition>
		<FooterBar/>

		<transition name="fade-in">
			<pop-view/>
		</transition>

		<transition name="fade-up">
			<pop-view name="notif" position="fill top"/>
		</transition>
	</div>
</template>

<script>
import HeaderBar from './components/common/HeaderBar'
import FooterBar from './components/common/FooterBar'

export default {
	name: 'app',

	components: {
		HeaderBar,
		FooterBar
	}
}
</script>